import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router";

interface Props {
    result: { created: number; updated: number; duplicates: number; errors: number; conflictCount: number; importLogId?: number };
    onNewImport: () => void;
}

export function ImportSummaryStep({ result, onNewImport }: Props) {
    const navigate = useNavigate();

    return (
        <div>
            <h2 className="mb-4 text-lg font-semibold">Import Complete</h2>
            <div className="grid grid-cols-2 gap-4 sm:grid-cols-4">
                <div className="rounded-md bg-green-50 p-4 text-center dark:bg-green-950">
                    <div className="text-3xl font-bold text-green-600">{result.created}</div>
                    <div className="text-sm text-muted-foreground">Created</div>
                </div>
                <div className="rounded-md bg-blue-50 p-4 text-center dark:bg-blue-950">
                    <div className="text-3xl font-bold text-blue-600">{result.updated}</div>
                    <div className="text-sm text-muted-foreground">Updated</div>
                </div>
                <div className="rounded-md bg-yellow-50 p-4 text-center dark:bg-yellow-950">
                    <div className="text-3xl font-bold text-yellow-600">{result.duplicates}</div>
                    <div className="text-sm text-muted-foreground">Duplicates</div>
                </div>
                <div className="rounded-md bg-red-50 p-4 text-center dark:bg-red-950">
                    <div className="text-3xl font-bold text-red-600">{result.errors}</div>
                    <div className="text-sm text-muted-foreground">Errors</div>
                </div>
            </div>
            <div className="mt-6 flex gap-2">
                <Button onClick={() => navigate("/contacts")}>View Contacts</Button>
                <Button variant="outline" onClick={onNewImport}>Import More</Button>
            </div>
        </div>
    );
}
